import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { useEntranceDisabled } from "@/lib/hydrationMotion";

export const Reveal = ({ children, className = "" }) => {
  const reduced = useReducedMotion();
  const noEntrance = useEntranceDisabled();
  return <motion.div className={className} initial={reduced || noEntrance ? false : { y: 14 }} whileInView={{ y: 0 }} viewport={{ once: true, amount: 0.12 }} transition={{ duration: 0.65, ease: [0.2, 0.65, 0.3, 1] }}>{children}</motion.div>;
};

export const TextLink = ({ to, children, testId, className = "", ...props }) => (
  <Link to={to} data-testid={testId} className={`rh-text-link ${className}`} {...props}>{children}<ArrowUpRight size={15} strokeWidth={1.4} aria-hidden="true" /></Link>
);

export const SectionLabel = ({ children, testId, number }) => (
  <h2 className="rh-label" data-testid={testId}>{number && <span aria-hidden="true">{number} / </span>}{children}</h2>
);